import http from "services";
import { SuccessResponse } from "types";
import {
  ChangeOwnPasswordInput,
  PasswordStaffInput,
  Staff,
  StaffCreateResponse,
  StaffInput,
  StaffWarehouseProduct,
  WarehouseDownloadInterface,
} from "./types";

namespace staff {
  export const list = {
    call: (body: any) => {
      return http.post<Staff[]>(`/admin/user/staff/list`, {
        hasAuth: true,
        body,
      });
    },
    permission: "user_staff_list",
  };
  export const exportCSV = {
    call: (body: any) => {
      return http.post<any>(`/admin/user/staff/export`, {
        hasAuth: true,
        body,
      });
    },
    permission: "user_staff_list_export",
  };
  export const create = {
    call: (data: StaffInput) => {
      return http.post<StaffCreateResponse>("/admin/user/staff/create", {
        body: data,
        hasAuth: true,
      });
    },
    permission: "user_staff_create",
  };
  export const update = {
    call: (id: number, data: StaffInput) => {
      return http.put<SuccessResponse>(`/admin/user/staff/update/${id}`, {
        body: data,
        hasAuth: true,
      });
    },
    permission: "user_staff_update_id",
  };
  export const remove = {
    call: (id: number) => {
      return http.del<SuccessResponse>(`/admin/user/staff/delete/${id}`, {
        hasAuth: true,
      });
    },
    permission: "user_staff_delete_id",
  };
  export const get = {
    call: (id: number) => {
      return http.get<Staff>(`/admin/user/staff/get/${id}`, {
        hasAuth: true,
      });
    },
    permission: "user_staff_get_id",
  };
  export const changePassword = {
    call: (id: number, data: PasswordStaffInput) => {
      return http.put<SuccessResponse>(`/admin/user/staff/password/${id}`, {
        body: data,
        hasAuth: true,
      });
    },
    permission: "user_staff_password_id",
  };

  // Self-service: the signed-in staff member rotates their own password. No
  // permission gate — every account may change its own credentials.
  export const changeOwnPassword = (data: ChangeOwnPasswordInput) =>
    http.put<SuccessResponse>("/admin/user/staff/change-password", {
      body: data,
      hasAuth: true,
    });

  export const unlock = {
    call: (id: number) => {
      return http.post<SuccessResponse>(`/admin/user/staff/unlock/${id}`, {
        hasAuth: true,
      });
    },
    permission: "user_staff_password_id",
  };

  export const verifyPassword = {
    call: (data: PasswordStaffInput) => {
      return http.post<SuccessResponse>(`/admin/user/staff/verify-password`, {
        body: data,
        hasAuth: true,
      });
    },
    permission: "user_staff_verify_password",
  };

  export const generateOtp = {
    call: (id: number) => {
      return http.get<string>(`/admin/user/staff/otp/${id}`, {
        hasAuth: true,
      });
    },
    permission: "user_staff_generate_otp",
  };

  export const warehouseProducts = {
    call: (body: any) => {
      return http.post<StaffWarehouseProduct[]>(
        `/admin/user/staff_warehouse/products`,
        {
          hasAuth: true,
          body,
        },
      );
    },
    permission: "user_staff_list",
  };

  export const warehouseProductsDownload = {
    call: (body: any) => {
      return http.post<WarehouseDownloadInterface[]>(
        `/admin/user/staff_warehouse/download`,
        {
          hasAuth: true,
          body,
        },
      );
    },
    permission: "user_staff_list",
  };
}

export default staff;
